if (!customElements.get('s10-gift-amounts')) {
  class StudioGiftAmounts extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const controls = this.querySelector('[data-presets]');
      const root = this.querySelector('.s10-order-form');
      const findAmount = tree => {
        const input = tree.querySelector('input[type="number"]');
        if (input) return input;
        for (const element of tree.querySelectorAll('*')) {
          if (element.shadowRoot) {
            const match = findAmount(element.shadowRoot);
            if (match) return match;
          }
        }
        return null;
      };
      const sync = field => {
        for (const btn of controls.querySelectorAll('button')) {
          btn.setAttribute('aria-pressed', String(!!field.value && btn.dataset.amount === field.value));
        }
      };
      const attach = () => {
        const amount = findAmount(root);
        if (!amount) return false;
        controls.hidden = false;
        sync(amount);
        amount.addEventListener('input', () => sync(amount), {signal:this.controller.signal});
        controls.addEventListener('click', e => {
          const btn = e.target.closest('[data-amount]');
          if (!btn) return;
          const current = findAmount(root);
          if (!current) return;
          Object.getOwnPropertyDescriptor(HTMLInputElement.prototype,'value').set.call(current,btn.dataset.amount);
          current.dispatchEvent(new Event('input',{bubbles:true,composed:true}));
          current.dispatchEvent(new Event('change',{bubbles:true,composed:true}));
          sync(current);
          if (!btn.dataset.amount) current.focus();
        }, {signal:this.controller.signal});
        return true;
      };
      let attempts = 0;
      const retry = () => {
        if (!attach() && ++attempts < 80) this.timer = setTimeout(retry,500);
      };
      retry();
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.controller?.abort();
      this.controller = null;
    }
  }
  customElements.define('s10-gift-amounts',StudioGiftAmounts);
}